import {List, Map} from 'immutable';
import moment from 'moment';
import request from 'superagent';

export const femaleShoeList = ['33 EU / 1 UK', '34 EU / 1.5-2 UK', '35 EU / 2.5-3 UK', '36 EU / 3.5 UK', '37 EU / 4-4.5 UK', '38 EU / 5-5.5 UK', '39 EU / 6 UK', '40 EU / 6.5-7 UK', '41 EU / 7.5 UK', '42 EU / 8-8.5 UK', '43 EU / 9 UK', '44 EU / 9.5-10 UK', '45 EU / 11.5 UK'];
export const maleShoeList = ['35 EU / 2 UK', '36 EU / 3-3.5 UK', '37 EU / 4 UK', '38 EU / 4.5-5 UK', '39 EU / 5.5-6 UK', '40 EU / 6.5 UK', '41 EU / 7-7.5 UK', '42 EU / 8 UK', '43 EU / 8.5-9 UK', '44 EU / 9.5 UK', '45 EU / 10-10.5 UK', '46 EU / 11 UK', '47 EU / 11.5-12 UK', '48 EU / 12.5 UK', '49 EU / 13 UK'];
export const childrenShoeList = ['19 EU / 2.5-3 UK', '20 EU / 3.5-4 UK', '21 EU / 4.5 UK', '22 EU / 5-5.5 UK', '23 EU / 6 UK', '24 EU / 6.5-7 UK', '25 EU / 7.5 UK', '26 EU / 8-8.5 UK', '27 EU / 9 UK', '28 EU / 9.5-10 UK', '29 EU / 10.5-11 UK', '30 EU / 11.5 UK', '31 EU / 12-12.5 UK', '32 EU / 13 UK', '33 EU / 13.5-1 UK', '34 EU / 1.5 UK', '35 EU / 2-2.5 UK', '36 EU / 3 UK', '37 EU / 3.5-4 UK', '38 EU / 4.5 UK', '39 EU - 5-5.5 UK', '40 EU / 6-6.5 UK'];

export const removeExtraFromRow = (state, rowId, extraType) => {
    return state.setIn(['rows', rowId, extraType], Map({}));
};

export const focusEquipmentHire = (state, rowId) => {
    return state.set('visibleEquipmentHireModal', rowId);
};

export const focusLiftPass = (state, rowId) => {
    return state.set('visibleLiftPassModal', rowId);
};

export const focusSkiSchool = (state, rowId) => {
    return state.set('visibleSkiSchoolModal', rowId);
};

/**
 * returns true if the date of birth is more than 18 year ago
 * @param {Moment} dateOfBirth moment
 * @param {Moment} compareDate moment to be compared to, if not supplied today's date is used
 * @returns {boolean}
 */
export const isChild = (dateOfBirth, compareDate = moment()) => {
    return compareDate.subtract(18, 'years').isBefore((typeof dateOfBirth === 'string' ? moment(dateOfBirth) : dateOfBirth));
};

export const addRow = (state) => {
    return state.set('rows', state.get('rows').push(state.get('emptyRow').set('dateOfBirth', moment())));
};

export const removeRow = (state, rowId) => {
    return state.set('rows', state.get('rows').deleteIn([rowId]));
};

export const setSkiInformationVisibility = (state, visible) => {
    return state.set('skiInformationVisible', visible);
};

export const updateSelectedExtraData = (state, rowId, extraKey, key, value) => {
    if (key === 'sex' && state.getIn(['rows', rowId, extraKey, 'sex']) !== value) {
        return state.setIn(['rows', rowId, extraKey, key], value).setIn(['rows', rowId, 'equipmentHire', 'shoeSize'], null);
    }

    if(key === 'type') {
        const duration = state.getIn(['availableExtras', extraKey, 'types', value, 'durationPrices', 0, 'duration'], 0);
        return state.setIn(['rows', rowId, extraKey, key], value).setIn(['rows', rowId, extraKey, 'duration'], duration);
    }

    return state.setIn(['rows', rowId, extraKey, key], value);
};

export const updatePersonDetails = (state, rowId, key, value) => {
    return state.setIn(['rows', rowId, key], value);
};

export const toFeet = (cm) => {
    const realFeet = ((cm * 0.393700) / 12);
    let feet = Math.floor(realFeet);
    let inches = Math.round((realFeet - feet) * 12);
    if (inches === 12) {
        feet++;
        inches = 0;
    }
    return `${feet} &prime; ${inches} &Prime;`;
};

/**
 * Returns the price of the selected skis and the duration
 * @param {Map} state
 * @param {int|null} [type]
 * @param {int|null} [duration]
 */
export const getSkiPriceByTypeAndDuration = (state, type = null, duration = null) => {
    if (type === null || duration === null) {
        return null;
    }
    const availableSkiTypes = state.getIn(['availableExtras', 'equipmentHire', 'types']);
    return availableSkiTypes.getIn([type, 'durationPrices', 0, 'price']);
};

/**
 * Returns the price of the selected skis and the duration
 * @param {Map} state
 * @param {int|null} [type]
 * @param {int|string|null} [duration]
 * @param {int|0} [age]
 */
export const getLiftPassPriceByTypeAndDuration = (state, type = null, duration = null, age = 0) => {
    if (type === null || duration === null) {
        return null;
    }
    const availableLiftPasses = state.getIn(['availableExtras', 'liftPasses', 'types']);
    return availableLiftPasses.getIn([type, 'durationPrices'], Map({})).filter(x => x.get('duration') === parseInt(duration) && x.get('maxAge') >= age && x.get('minAge') <= age).getIn([0, 'price']);
};

/**
 * Returns the price of the selected ski school
 * @param {Map} state
 * @param {int|null} [type]
 * @param {int|0} [age]
 */
export const getSkiSchoolPriceByType = (state, type = null, age = 0) => {
    if (type === null) {
        return null;
    }
    const availableSkiSchoolTypes = state.getIn(['availableExtras', 'skiSchool', 'types']);
    return availableSkiSchoolTypes.getIn([type, 'durationPrices'], Map({})).filter(x => x.get('maxAge') >= age && x.get('minAge') <= age).getIn([0, 'price']);
};

/**
 * Returns the name of the selected ski school
 * @param {Map} state
 * @param {int|null} [type]
 */
export const getSkiSchoolNameByType = (state, type = null) => {
    if (type === null) {
        return null;
    }
    const availableSkiSchoolTypes = state.getIn(['availableExtras', 'skiSchool', 'types']);
    return `${availableSkiSchoolTypes.getIn([type, 'name'], Map({}))} - (${availableSkiSchoolTypes.getIn([type, 'durationPrices', 0, 'duration'])} days)`;
};

/**
 * Returns the name of the selected ski school
 * @param {Map} state
 * @param {int|null} [type]
 */
export const getLiftPassNameByType = (state, type = null) => {
    if (type === null) {
        return null;
    }
    const availableLiftPassTypes = state.getIn(['availableExtras', 'liftPasses', 'types']);
    return availableLiftPassTypes.getIn([type, 'name'], Map({}));
};

/**
 * Returns the name of the selected ski school
 * @param {Map} state
 * @param {string} key
 * @param {int|null} [type]
 * @param {int|0} [age]
 */
export const getExtraNameByType = (state, key, type = null, age = 0) => {
    if (type === null) {
        return null;
    }
    const availableExtraTypes = state.getIn(['availableExtras', key, 'types']);
    const ageBands = availableExtraTypes.getIn([type, 'durationPrices']).groupBy(x => x.get('duration'));
    let suffix = '';
    if (ageBands.toList().get(0).count() > 1) {
        const band = ageBands.toList().get(0).sortBy(x => x.get('minAge'));
        suffix = ((band.get(0).get('minAge') <= age && band.get(0).get('maxAge') >= age) ? ' (Child)' : ' (Adult)');
    }
    return `${availableExtraTypes.getIn([type, 'name'], Map({}))}${suffix}`;
};

/**
 * Returns the price of the selected extras given type and duration
 * @param {Map} state
 * @param {int|0} [type]
 * @param {string} [key]
 * @param {string|int|0} [duration_]
 * @param {int|0} [age]
 */
export const getExtraPriceByTypeAndDuration = (state, key, type = 0, duration_ = 0, age = 0) => {

    if (type === null || duration_ === null || duration_ === 'please-select' || age === 0) {
        return 0;
    }
    const duration = parseInt(duration_);
    const availableExtras = state.getIn(['availableExtras', key, 'types']);
    return duration_ === 0 ? availableExtras.getIn([type, 'durationPrices'], Map({})).filter(x => x.get('minAge') <= age && x.get('maxAge') >= age).getIn([0, 'price']) : availableExtras.getIn([type, 'durationPrices']).filter(x => x.get('duration') === duration && x.get('minAge') <= age && x.get('maxAge') >= age).getIn([0, 'price']);
    /*if(duration_ === 'please-select') {
        return 0;
    }
    const duration = parseInt(duration_);
    console.log(type, duration, age);
    */
};

export const getSkiSchoolPriceRows = (state) => {
    const rows = state.get('rows');
    let priceRows = Map({});

    rows.valueSeq().forEach(value => {
        if (!isSkiSchoolRowValid(value)) {
            return;
        }
        const age = calculateAge(state.get('bookingEndDate'), value.get('dateOfBirth'));
        const type = value.getIn(['skiSchool', 'type']);
        const price = getSkiSchoolPriceByType(state, type, age);
        const name = getSkiSchoolNameByType(state, type);
        const count = priceRows.getIn([type, 'count'], 0);

        if (name === null || price === null) {
            return;
        }

        priceRows = priceRows.set(type, Map({
            price,
            name,
            count: count + 1
        }));
    });
    return priceRows;
};

export const getLiftPassPriceRows = (state) => {
    const rows = state.get('rows');
    let rowList = Map({});
    rows.forEach(row => {
        const age = calculateAge(state.get('bookingEndDate'), row.get('dateOfBirth'));
        const name = getExtraNameByType(state, 'liftPasses', row.getIn(['liftPasses', 'type']), age);
        const price = getExtraPriceByTypeAndDuration(state, 'liftPasses', row.getIn(['liftPasses', 'type'], Map({})), 0, age);
        const duration = state.getIn(['availableExtras', 'liftPasses', 'types', row.getIn(['liftPasses', 'type'], Map({})), 'durationPrices'], Map({})).filter(x => x.get('minAge') <= age && x.get('maxAge') >= age).getIn([0, 'duration']);
        if (name === null) {
            return;
        }
        const line = rowList.getIn([name], Map({name, count: 0, price, duration}));
        rowList = rowList.setIn([name], line.set('count', line.get('count', 0) + 1));
    });


    return rowList;
};

export const getSkiHirePriceRows = (state) => {
    const rows = state.get('rows');
    let priceRows = Map({});

    rows.valueSeq().forEach(value => {
        if (!isSkiHireRowValid(value)) {
            return;
        }
        priceRows = updatePriceRows(state, value, 'equipmentHire', priceRows);
    });

    return priceRows;
};

export const isSkiHireRowValid = value => {
    const selectedEquipmentData = value.getIn(['equipmentHire'], Map({}));
    const selectedSex = selectedEquipmentData.get('sex', 'please-select');
    const selectedHeight = selectedEquipmentData.get('height', 'please-select');
    const selectedShoeSize = selectedEquipmentData.get('shoeSize', 'please-select');
    const selectedSkiType = selectedEquipmentData.get('type', null);
    const helmetRequired = selectedEquipmentData.get('helmet');

    return (((helmetRequired && selectedSkiType === null) || ((selectedSkiType !== null) && (selectedShoeSize !== 'please-select' && selectedShoeSize !== null) && (selectedSex !== 'please-select' && selectedSex !== null) && (selectedHeight !== 'please-select' && selectedHeight !== null))));
};

export const isSkiSchoolRowValid = value => {
    const selectedSkiSchoolData = value.getIn(['skiSchool'], Map({}));
    const selectedSkiSchoolType = selectedSkiSchoolData.get('type', null);
    const selectedLevel = selectedSkiSchoolData.get('level', 'please-select');

    return (selectedSkiSchoolType !== null && selectedLevel !== 'please-select');
};


export const isLiftPassRowValid = value => {
    const selectedSkiSchoolData = value.getIn(['liftPasses'], Map({}));
    const selectedLiftPassType = selectedSkiSchoolData.get('type', null);
    //const selectedDuration = selectedSkiSchoolData.get('duration', 'please-select');

    return (selectedLiftPassType !== null);
};

export const getHelmetPrice = (state, dateOfBirth) => {
    const birthdate = moment(dateOfBirth);
    const nextDate = birthdate.add(13, 'years');
    const isThirteenOrUnder = nextDate.isAfter(moment());//isChild(dateOfBirth, moment().subtract(5, 'years')); //need to know this for helmet
    return state.getIn(['availableExtras', 'equipmentHire', 'helmetPrices', (isThirteenOrUnder ? 'child' : 'adult')], null);
};

export const getHelmetPriceRows = (state) => {
    const rows = state.get('rows');
    let priceRows = Map({});

    rows.valueSeq().forEach(value => {
        const helmetRequired = value.getIn(['equipmentHire', 'helmet'], false);
        if (!helmetRequired) {
            return;
        }
        if (!isSkiHireRowValid(value)) {
            return;
        }

        const dateOfBirth = value.get('dateOfBirth');

        const isThirteenOrUnder = isChild(dateOfBirth, moment().subtract(5, 'years')); //need to know this for helmet
        const adultOrChild = isThirteenOrUnder ? 'child' : 'adult';
        const count = priceRows.getIn(['helmet', adultOrChild, 'count'], 0);

        priceRows = priceRows.setIn(['helmet', adultOrChild], Map({
            count: count + 1,
            price: getHelmetPrice(state, dateOfBirth)
        }));

    });
    return priceRows;
};

export const calculateAge = (bookingDate, birthDate) => moment(bookingDate).diff(moment(birthDate), 'years');

const updatePriceRows = (state, row, key, priceRows, age) => {
    const type = row.getIn([key, 'type']);
    let duration = state.getIn(['availableExtras', key, 'types', type, 'durationPrices'], Map({})).filter(x => x.get('minAge') <= age && x.get('maxAge') >= age).getIn([0, 'duration']);
    let _price;

    if (key === 'equipmentHire') {
        duration = state.getIn(['availableExtras', key, 'types', type, 'durationPrices', 0, 'duration']);
        _price = state.getIn(['availableExtras', key, 'types', type, 'durationPrices', 0, 'price']);
    }

    const price = key === 'equipmentHire' ? _price : getExtraPriceByTypeAndDuration(state, key, type, duration, age);
    const name = getExtraNameByType(state, key, type, age);
    const count = priceRows.getIn([type, duration, 'count'], 0);

    if (name === null || price === null || duration === null) {
        return priceRows;
    }

    return priceRows.setIn([type, duration], Map({
        price,
        name,
        count: count + 1
    }));
};

export const startSubmitExtras = state => state.setIn(['submissionInProgress'], true);
export const stopSubmitExtras = state => state.setIn(['submissionInProgress'], false);
export const bookingComplete = (state, override = false) => state.setIn(['bookingComplete'], override);

export const submitExtrasAjax = (state) => {
    const availableExtrasJson = JSON.stringify(state.getIn(['skiExtras', 'availableExtras']).toJS());
    const bookingEndDate = state.getIn(['skiExtras', 'bookingEndDate']);
    const bookingStartDate = state.getIn(['skiExtras', 'bookingStartDate']);
    const bookingRef = state.getIn(['skiExtras', 'bookingRef']);
    const rows = JSON.stringify(state.getIn(['skiExtras', 'rows']).toJS());
    return request.post('/umbraco/surface/ClientArea/SubmitSkiExtras')
        .send({rows, bookingRef, availableExtrasJson, bookingEndDate, bookingStartDate});
};

export const resetDefaultRows = (state) => state.set('rows', state.get('defaultRows', List([])));
